import { render, staticRenderFns } from "./ContentAddEditClient.vue?vue&type=template&id=6f4ef36e&scoped=true"
import script from "./ContentAddEditClient.vue?vue&type=script&lang=js"
export * from "./ContentAddEditClient.vue?vue&type=script&lang=js"
import style0 from "./ContentAddEditClient.vue?vue&type=style&index=0&id=6f4ef36e&prod&scoped=true&lang=scss"
import style1 from "./ContentAddEditClient.vue?vue&type=style&index=1&id=6f4ef36e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4ef36e",
  null
  
)

export default component.exports